<template>
  <div class="jdTempsDetails">
    <div class="headerTitle pr bg_fff">
      <div class="back pa f_14 color_90 cursor_p" @click="$router.push({path:'/talent/jd_temps'})"><span class="iconfont iconzuo"></span>返回</div>
      <div class="title text_center f_25 color_40 font_w_b">{{level4Data.name}}</div>
    </div>

    <div class="content pr flex bg_fff">
      <!-- <div class="leftBg pa"></div> -->
      <div class="left pr">
        <div class="list">
          <template v-for="(item,index) in level4Data.data">
            <div class="item cursor_p f_16 pr transition_2"
              :key="String(index)" :class="level4Token === item.token?'active color_40 bg_fff':'color_90'"
              @click="toggleLevel4(item)"
            >{{item.title}}</div>
          </template>
        </div>
      </div>
      <div class="right flex1 pr" v-loading="isLoading">
        <div class="top flex">
          <div class="flex1 clearfix">
            <div class="title fl f_14 color_90 cursor_p" v-for="item in jd_temps" :key="item.token" :class="item.token===jd_tempsToken?'active color_blue':''" @click="toggleJdTemps(item)">{{item.title}}</div>
          </div>
          <div class="title fl f_14 color_blue cursor_p active title2" @click="$router.push({path:`/talent/jobedit/create?jd_temp=${jd_tempsToken}`})">使用模板</div>
        </div>
        <div class="html color_60 f_16" v-html="jd_tempsHtml"></div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
// 所有接口
import actions from '@/actions/index'
//混入优化
import {mixinsUtils} from '@/mixins/search/utils';

import {checkUserState, get_tUser , toLogin} from '@/utils/utils';


export default {
  name: 'jdTempsDetails',
  data(){
    return {
      professionId:'',
      isLoading:false,//是否在请求列表
      userJWT:{},
      level4Data:{},
      level4Token:'',
      jd_temps:[],
      jd_tempsName:{
        0:'一',
        1:'二',
        2:'三',
        3:'四',
        4:'五',
        5:'六',
        6:'七',
        7:'八',
        8:'九',
        9:'十',
      },
      jd_tempsToken:'',
      jd_tempsHtml:'',
    }
  },
  computed:{
    ...mapState('block',['userInfoState','windowInnerWidth']),
  },
  mixins:[mixinsUtils],
  async created(){
    this.userJWT = await get_tUser();
    if(this.userJWT.h_t){
      //更新是否完善信息(状态库)
      let userInfo = await actions.hr_accounts.getUserinfo();
      this.toggleUserInfoState(userInfo)
    }else{
      this.toggleUserInfoState(false)
    }
    let { professionId='' } = this.$route.params;
    this.professionId = professionId;
    this.getList();
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState']),
    getList(){
      this.isLoading = true;
      actions.jd_temps.get_jd_temps_level4_list(this.professionId).then(res=>{
        if(res.code=== 1000){
          this.level4Data = res.data;
          this.level4Token = res.data.data.length?res.data.data[0].token:'';
          //获取模板列表
          this.get_jd_temp_show();
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //获取模板列表
    get_jd_temp_show(){
      this.isLoading = true;
      actions.jd_temps.get_jd_temp_list(this.level4Token).then(res=>{
        this.isLoading = false;
        if(res.code=== 1000){
          let { title, temps} = res.data;
          temps.forEach((item,index)=>{

            // if(item.content.split(`<strong>职位描述：</strong><br>`).length>1){
            //   let content = item.content.split(`<strong>职位描述：</strong>`);
            //   item.content = content[content.length-1];
            // }
            // if(item.content.split(`<strong>职位描述</strong>：<br>`).length>1){
            //   let content = item.content.split(`<strong>职位描述</strong>：`);
            //   item.content = content[content.length-1];
            // }
            // item.content = item.content.replace(/\<br> <br>/g, '<br>' )
            // item.content = item.content.replace(/\<br><br><br>/g, '<br>' )
            // item.content = item.content.replace(/\<br><br>/g, '<br>' )
 
            // item.content = `<strong>职位描述：</strong>`+item.content
            // item.content = item.content.split(`</div>`)[0];
            // item.content = item.content.split(`<strong>${title}（模板${this.jd_tempsName[index]}）</strong>`).join('');
            // item.content = item.content.split(`<strong>${title}职位描述（模板${this.jd_tempsName[index]}）</strong>`).join('');
            
            item.title = `模板${this.jd_tempsName[index]}`
          })
          this.jd_temps = temps;
          this.jd_tempsToken = temps[0].token;
          this.jd_tempsHtml = temps[0].content;
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //切换左侧四级菜单
    toggleLevel4(item){
      if(this.isLoading || this.level4Token===item.token){
        return false;
      }
      this.level4Token = item.token;
      this.get_jd_temp_show();
    },
    //切换模板
    toggleJdTemps(item){
      this.jd_tempsToken = item.token;
      this.jd_tempsHtml = item.content;
    },
  },
}
</script>
<style lang="scss" scoped>

@import './Index.scss';

</style>
